import React from 'react';
import {EditingFieldsType} from '../constants';
import {CircularLoader} from '../../../components/CircularLoader/CircularLoader';
import {EditingDialog, SelectedEntity} from '../../../components/EditingDialog';

type FieldsEditorProps = {
    isLoading: boolean;
    updateFields: (entityId: string, fields: Array<string>, cbc?: () => void) => void;
    isOpen: boolean;
    closeDialog: () => void;
    entity: {
        selectedEntity: SelectedEntity;
        defaultFields: Array<string>;
        helpText?: string;
        dialogTitle?: string;
    };
};

export const AdvancedDeliveryFieldsEditor = ({
    isLoading,
    updateFields,
    isOpen,
    closeDialog,
    entity
}: FieldsEditorProps) => {
    if (isLoading) {
        return <CircularLoader />;
    } else {
        const {selectedEntity, defaultFields, helpText, dialogTitle} = entity;
        const maxSelectableFields =
            selectedEntity.entityId === EditingFieldsType.RouteTitle
                ? undefined
                : selectedEntity.cols.filter(col => !col.Hidden).length;

        return (
            <EditingDialog
                selectedEntity={selectedEntity}
                updateFields={updateFields}
                closeDialog={closeDialog}
                isOpen={isOpen}
                defaultFields={defaultFields}
                specialHelpText={helpText}
                specialTitle={dialogTitle}
                maxSelectableFields={maxSelectableFields}
            />
        );
    }
};
